<template>
  <div>
    <el-card>
      <!-- 城市初选、复选试卷管理：创建试卷、上传题目、预览、修改等。 -->
      <div class="page-desc">创建试卷、上传题目、预览、修改等。用于初选/区域决选小程序答题、总决选第一轮小程序答题。</div>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        label-width="110px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                disabled
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.activityType"
                @change="getRaceSchedules"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
              >
                <el-option
                  v-for="item in raceSchedules"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="quizLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.quizLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="试卷名称" prop="formName">
              <el-input
                v-model="queryForm.formName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="resetFn"
            >重置</el-button
          >
        </el-col>
      </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">试卷列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog()"
            >创建试卷</el-button
          >
        </el-col>
      </el-row>
      <!-- 列表表格区域 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="试卷名称" prop="formName" width="180px"></el-table-column>
        <el-table-column label="答题说明" prop="formAudioUrl">
          <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.formAudioUrl" plain class="play-audio" @click="controlFn(scope.row.formAudioUrl)">
              <i class="iconfont icon-yinpinaudio47"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="套数" prop="quizSet">
          <template slot-scope="scope">
            第{{ scope.row.quizSet }}套
          </template>
        </el-table-column>
        <el-table-column label="试卷类型" prop="isForm">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isForm === 1 ? 'success' : ''" size="mini">{{scope.row.isForm === 1 ? '正式卷' : '备用卷'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="试卷状态" prop="quizIng">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.quizIng === 1" size="mini">比赛试卷</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="答题时长" prop="formTimeStr">
          <template slot-scope="scope">
            {{scope.row.formTimeStr}}
          </template>
        </el-table-column>
        <el-table-column label="赛程" prop="raceSchedule" :formatter="raceScheduleFormatter"></el-table-column>
        <el-table-column label="组别" prop="formLevel" :formatter="groupFormatter"></el-table-column>
        <el-table-column label="创建者" prop="creator"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" width="170px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="handleToEdit(scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-document"
              @click="handleToDetail(scope.row)"
            >查看题目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 录音播放 -->
    <audio ref="audioPlayer" @ended="pause"></audio>
    <el-dialog
      :title="editType === 0 ? '创建试卷' : '修改试卷'"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      >
      <el-form
        :model="addForm"
        :rules="addFormRules"
        label-width="110px"
        ref="addFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.activityType"
                disabled
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.raceSchedule"
              >
                <el-option
                  v-for="item in raceSchedules"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组别" prop="quizLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.quizLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试卷类型" prop="isForm">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.isForm"
              >
                <el-option label="正式卷" :value="1"></el-option>
                <el-option label="备用卷" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item prop="quizSet"> -->
            <div style="margin-left: 92px;">
              第 <el-input-number v-model="addForm.quizSet" :min="1" style="width: 140px;"></el-input-number> 套
            </div>
            <!-- </el-form-item> -->
          </el-col>
          <el-col :span="24">
            <el-form-item label="答题时长" prop="formTime">
              <el-input style="width: 160px;"
                v-model="addForm.formTime"
                placeholder="请输入"
              ></el-input>
              秒
              <span style="color: #999; font-size: 12px;margin-left: 12px;" v-if="addForm.raceSchedule === '2'">答题时长为线上小程序答题总时长</span>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-form-item label="试卷名称" prop="formName">
              <el-input
                v-model="addForm.formName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="设置为比赛试卷" prop="quizIng">
              <el-switch v-model="quizIng" @change="switchChange"></el-switch>
              <el-tooltip class="item" effect="dark" content="同一赛程同一组别只能设置一套比赛试卷" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="答题说明中文" prop="formExplain">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入"
                v-model="addForm.formExplain">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="答题说明英文" prop="questionExplain">
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入"
                v-model="addForm.questionExplain">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="editType === 0">
            <el-form-item label="上传题目" prop="formName">
              <el-upload
                class="upload-demo"
                drag
                ref="uploadFileRef"
                :action="uploadInfo.uploadUrl"
                :headers="uploadInfo.headerObj"
                :data="addForm"
                :before-upload="beforeUpload"
                :limit="1"
                :on-success="uploadSuccess"
                :on-error="uploadError">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持上传Excel文件， <em class="tip" @click="downLoadFn">点击下载模版</em></div>
              </el-upload>
              <div class="rule-tip">
                图片命名规则：<br/>
                城市初选 1 区域决选 2
                城市初选_组名_题号_选项号.png（例如 1_Advanced_13_1.png）<br/>
                小初组 Beginner 小中组Intermediate 小高组Advanced 初中组Middle
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer" v-if="editType === 1">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="saveFn">保存</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="修改试卷名称"
      :visible.sync="editVisible"
      width="500px"
      :close-on-click-modal="false"
      >
      <span class="label">试卷名称</span>
      <el-input
        style="width: 320px;"
        v-model="formName"
        placeholder="请输入"
        clearable
      ></el-input>
      <div class="footer">
        <el-button @click="handleCloseEdit">取消</el-button>
        <el-button type="primary" @click="saveFn">保存</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import env from '@/http/env'

export default {
  data () {
    return {
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_group: this.$userInfo.dict_group(),
      raceSchedules: [],
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        // quizSet: '', // 待定
        quizLevel: '',
        // quizForm: '', // 题型先不写
        formName: ''
      },
      total: 0,
      dataList: [],
      visible: false,
      addForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        quizLevel: '',
        formName: '',
        isForm: '',
        formExplain: '',
        questionExplain: '',
        quizIng: 0,
        quizSet: 1,
        formTime: ''
      },
      addFormRules: {
        raceSchedule: [{ required: true, message: '请选择', trigger: 'change' }],
        quizLevel: [{ required: true, message: '请选择', trigger: 'change' }],
        formName: [{ required: true, message: '请输入', trigger: 'blur' }],
        isForm: [{ required: true, message: '请选择', trigger: 'change' }],
        formExplain: [{ required: true, message: '请输入', trigger: 'blur' }],
        questionExplain: [{ required: true, message: '请输入', trigger: 'blur' }],
        formTime: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      quizIng: false,
      editType: 0,
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}formQuiz/importOnlineFormAnswers`,
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      editVisible: false,
      formName: '',
      editId: '',
      playing: false
    }
  },
  created () {
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    init () {
      this.getRaceSchedules()
    },
    getRaceSchedules () {
      this.dataList = []
      this.$http.get('raceSchedule/queryRaceSchedule', { params: { activityType: this.queryForm.activityType } }).then(res => {
        if (res.code === 200) {
          this.raceSchedules = res.data
          this.getList()
        }
      })
    },
    getList () {
      this.$http.get('formQuiz/queryFormQuizPage', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data.list
          this.dataList.forEach(item => {
            item.formTimeStr = this.$xcUtils.formatSeconds(item.formTime)
          })
        }
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    resetFn () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.activityType = String(this.$chnEngStatusCode.activityType)
      this.queryForm.season = this.$chnEngStatusCode.defaultSeason
      this.getRaceSchedules()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleToDetail (item) {
      const formInfo = {
        activityType: item.activityType,
        raceSchedule: item.raceSchedule,
        season: item.season,
        quizLevel: item.formLevel
      }
      this.$router.push(`/academic_Management/paper_detail?id=${item.id}&paper=${item.formName}&type=1&formInfo=${JSON.stringify(formInfo)}`)
    },
    groupFormatter (data) {
      return data.formLevel ? this.dict_group.find(item => item.dictCode === data.formLevel).dictLabel : '--'
    },
    raceScheduleFormatter (data) {
      return this.raceSchedules.find(item => item.id === String(data.raceSchedule)).scheduleName
    },
    showDialog () {
      this.editType = 0
      this.visible = true
    },
    handleClose () {
      this.$refs.addFormRef.resetFields()
      this.addForm = {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        quizLevel: '',
        formName: '',
        isForm: '',
        quizIng: 0,
        quizSet: 1,
        formExplain: '',
        questionExplain: '',
        formTime: ''
      }
      this.quizIng = false
      this.visible = false
    },
    // 下载模板
    downLoadFn () {
      var downLoadUrl = env.baseIP + 'formQuiz/exportTheOnlineFormAnswerTemplate'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, {})
    },
    beforeUpload (file) {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.$message.error('请选择Excel文件上传')
          return false
        }
      })
    },
    uploadSuccess (res) {
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.handleClose()
        this.searchFn()
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.uploadFileRef.clearFiles()// 清除文件
    },
    uploadError (error) {
      console.log('uploadError', error)
    },
    handleToEdit (item) {
      this.editType = 1
      this.visible = true
      // this.formName = item.formName
      this.editId = item.id
      console.log(item)
      this.addForm.activityType = String(item.activityType)
      this.addForm.season = item.season
      this.addForm.raceSchedule = String(item.raceSchedule)
      this.addForm.quizLevel = String(item.formLevel)
      this.addForm.formName = item.formName
      this.addForm.isForm = item.isForm
      this.addForm.quizIng = item.quizIng
      this.addForm.quizSet = item.quizSet
      this.addForm.formExplain = item.formExplain
      this.addForm.questionExplain = item.questionExplain
      this.addForm.formTime = item.formTime
      this.quizIng = item.quizIng === 1
    },
    saveFn () {
      console.log(this.addForm)
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        this.$http.post('formQuiz/updateFormQuiz', { ...{ id: this.editId }, ...this.addForm }).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.getList()
            this.handleClose()
          }
        })
      })
    },
    switchChange (e) {
      this.addForm.quizIng = e ? 1 : 0
    },
    controlFn (url, item) {
      if (this.playing) {
        this.pause()
      } else {
        this.play(url)
      }
    },
    play (url) {
      if (this.playing) return
      this.playing = true
      this.$refs.audioPlayer.src = url
      this.$refs.audioPlayer.play()
    },
    pause () {
      this.playing = false
      this.$refs.audioPlayer.pause()
    }
  }
}
</script>
<style scope lang="less">
.tip{
  line-height: initial;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  width: 74px;
}
.rule-tip{
  color: #999;
  font-size: 12px;
  line-height: 20px;
  margin-top: 10px;
}
.el-upload__tip{
  margin-top: 0;
  line-height: 20px;
}
.footer{
  text-align: center;
  margin-top: 24px;
}
.label{
  margin-right: 12px;
}
.el-icon-question{
  color: #E6A23C;
  font-size: 18px;
  margin-left: 10px;
}
.page-desc{
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  background: #F0F8FF;
  border-radius: 10px;
  padding: 14px 20px;
}
.play-audio.el-button--primary.is-plain{
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 0;
}
</style>
